module.exports = __webpack_public_path__ + "img/co-branding-logo-subway.22e08308.png";